import { connect } from "react-redux"

import {
    insightAreaAddPlaceholderImages,
    insightAreaUpdatePlaceholderAttribution,
    insightAreaRemovePlaceholder
} from "../../../../actions/insight-area-actions"

import PlaceholderImageEditWidget from "../../../common/PlaceholderImageEditWidget"

const mapDispatchToProps = (dispatch, props) => ({
    ...props,
    onAddPlaceholders: files =>
        dispatch(insightAreaAddPlaceholderImages(files)),
    onUpdatePlaceholder: placeholder =>
        dispatch(insightAreaUpdatePlaceholderAttribution(placeholder)),
    onRemovePlaceholder: placeholderId =>
        dispatch(insightAreaRemovePlaceholder(placeholderId))
})

export default connect(null, mapDispatchToProps)(PlaceholderImageEditWidget)
